import { FcShape } from '@dtx-company/flowcode-generator-browser'
import type { FcGeneratorOptions } from '@dtx-company/flowcode-generator-types'

const DEFAULT_LOGO_IMAGE_URL =
  'https://cdn.flowcode.com/prodassets/Asset_1_2sMX5Jq.svg?ts=1693504715'

/**
 * Adds branding to a Flowcode's eye by updating the outerShape of a position element.
 * This util updates the top right position element for rotated codes
 * and the bottom left position element for unrotated ones.
 *
 * @param {FcGeneratorOptions} options - Flowcode generator options
 * @returns {boolean}
 */
export const addEyeBrandingToConfig = (options: FcGeneratorOptions): void => {
  if (options.qrrotate) {
    options.positionElementTopRight = {
      ...options.positionElementTopRight,
      outerShape: FcShape.LOGO,
      ...(options.positionElementTopRight?.imageUrl && {
        imageUrl: DEFAULT_LOGO_IMAGE_URL
      })
    }
  } else {
    options.positionElementBottomLeft = {
      ...options.positionElementBottomLeft,
      outerShape: FcShape.LOGO,
      ...(options.positionElementBottomLeft?.imageUrl && {
        imageUrl: DEFAULT_LOGO_IMAGE_URL
      })
    }
  }
}
